import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-514f2840"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "channels-section p-grid p-mt-6 p-mt-lg-0 p-d-flex p-flex-column p-ml-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Channels", -1))
const _hoisted_3 = { class: "p-grid p-d-flex p-flex-column" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "p-d-flex" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "flex p-flex-column p-justify-center p-mr-3 channel-stat" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "subs", -1))
const _hoisted_11 = { class: "p-text-bold" }
const _hoisted_12 = { class: "flex p-flex-column p-justify-center p-mr-3 channel-stat" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "total views", -1))
const _hoisted_14 = { class: "p-text-bold" }
const _hoisted_15 = { class: "flex p-flex-column p-justify-center p-mr-3 channel-stat" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "total videos", -1))
const _hoisted_17 = { class: "p-text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_empty_list = _resolveComponent("empty-list")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuOptions, (item, index) => {
            return (_openBlock(), _createElementBlock("button", {
              onClick: ($event: any) => (_ctx.tabviewDraft = index),
              class: _normalizeClass(["nav_item p-col-1", [ _ctx.tabviewDraft === index ? _ctx.activeClass : '' ]]),
              key: `${index}_menu`
            }, _toDisplayString(item), 11, _hoisted_4))
          }), 128))
        ]),
        (_ctx.authUser?.isCreator())
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openConnectPopup && _ctx.openConnectPopup(...args))),
              type: "button",
              class: "add-channel-btn"
            }, " add channel "))
          : _createCommentVNode("", true),
        _createVNode(_component_TabView, {
          activeIndex: _ctx.tabviewDraft,
          "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabviewDraft) = $event))
        }, {
          default: _withCtx(() => [
            (_ctx.channelsYT && _ctx.channelsYT.length)
              ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelsYT, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${index}_yt`,
                        class: "p-d-flex p-ai-center p-mb-3"
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("img", {
                              src: item?.snippet?.thumbnails?.default?.url,
                              class: "image"
                            }, null, 8, _hoisted_7),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(item?.snippet?.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createElementVNode("span", _hoisted_11, _toDisplayString(item?.statistics?.subscriberCount), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item?.statistics?.viewCount), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(item?.statistics?.videoCount), 1)
                          ])
                        ]),
                        (_ctx.authUser?.isAgencyOwner())
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              severity: "danger",
                              onClick: (event) => _ctx.openConfirmRemoveModal(event, item),
                              class: "add-channel-btn remove"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" remove ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ]),
      (!_ctx.menuOptions.length)
        ? (_openBlock(), _createBlock(_component_empty_list, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}